/* CVO: header icon labels + account drawer. Works on top of the native header markup.
   The drawer itself is the theme's <side-drawer>, so it shares the cart drawer's overlay and animation. */
if (!customElements.get('cvo-account-drawer')) {
  class CvoAccountDrawer extends HTMLElement {
    connectedCallback() {
      this.drawer = this.querySelector('side-drawer');

      // Move the drawer to <body> (like the cart drawer) so the sticky header can't sit above it.
      if (this.drawer) {
        document.querySelectorAll(`body > #${this.drawer.id}`).forEach((old) => old.remove());
        document.body.appendChild(this.drawer);

        // Keep drawer links (My Account, Change location, Log out) in the same tab. New customer
        // accounts live on shopify.com, so the theme's "open external links in new tab" setting
        // would otherwise add target="_blank" on click. Stopping propagation here keeps that
        // document-level handler from running for these links only.
        this.drawer.addEventListener('click', (evt) => {
          const link = evt.target.closest('a[href]');
          if (!link) return;
          link.target = '_self';
          evt.stopPropagation();
        });
      }

      this.onDocumentClick = this.onDocumentClick.bind(this);
      document.addEventListener('click', this.onDocumentClick);

      this.addLabels();

      // The header may be re-rendered (e.g. in the theme editor), so re-apply labels.
      this.headerObserver = new MutationObserver(() => this.addLabels());
      const header = document.querySelector('.header__icons')?.closest('.shopify-section');
      if (header) this.headerObserver.observe(header, { childList: true, subtree: true });
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.onDocumentClick);
      if (this.headerObserver) this.headerObserver.disconnect();
      if (this.drawer && this.drawer.hasAttribute('open')) this.drawer.close();
      if (this.drawer) this.drawer.remove();
    }

    getAccountLinks() {
      const { accountUrl, loginUrl } = this.dataset;
      return [...document.querySelectorAll('.header__icons a.header__icon')].filter((link) => {
        const path = link.getAttribute('href');
        return path === accountUrl || path === loginUrl;
      });
    }

    addLabels() {
      if (this.dataset.showLabels !== 'true') return;

      const add = (link, text) => {
        if (!link || !text || link.querySelector('.cvo-icon-label')) return;
        const label = document.createElement('span');
        label.className = 'cvo-icon-label';
        label.setAttribute('aria-hidden', 'true');
        label.textContent = text;
        link.classList.add('cvo-has-label');
        link.appendChild(label);
      };

      this.getAccountLinks().forEach((link) => add(link, this.dataset.accountLabel));
      add(document.getElementById('cart-icon'), this.dataset.cartLabel);
    }

    onDocumentClick(evt) {
      if (this.dataset.enableDrawer !== 'true' || !this.drawer || typeof this.drawer.open !== 'function') return;
      const link = evt.target.closest('.header__icons a.header__icon');
      if (!link || !this.getAccountLinks().includes(link)) return;

      evt.preventDefault();
      this.drawer.open(link);
    }
  }

  customElements.define('cvo-account-drawer', CvoAccountDrawer);
}
